// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'normalize.css'
import '@babel/polyfill'
import svg4everybody from 'svg4everybody'
import Vue from 'vue'
import App from './App'
import router from './router'

import VueMeta from 'vue-meta'
import VueResource from 'vue-resource'
import VueYoutube from 'vue-youtube'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueLazyload from 'vue-lazyload'
import WebFont from 'webfontloader'
import VueGtag from 'vue-gtag'
import VueYandexMetrika from 'vue-yandex-metrika'
// import VueJivosite from '@bchteam/vue-jivosite'

// FontAwesome's js injects some inline styles for svg icons.
// Due to this, the size of the renedered html pages unreasonably increases.
// To solve this issue, import svg styles manually. Solution is taken from
// https://github.com/FortAwesome/vue-fontawesome/issues/86
import '@fortawesome/fontawesome-svg-core/styles.css'
import { config } from '@fortawesome/fontawesome-svg-core'
config.autoAddCss = false

Vue.use(VueMeta)
Vue.use(VueResource)
Vue.use(VueYoutube)
Vue.use(VueGoogleMaps, {
  // There is a known bug when Google maps script is injected twice
  // during the prerendering, see the following issue:
  // https://github.com/xkjyeah/vue-google-maps/issues/430
  load: window['__PRERENDER_INJECTED']
    ? null
    : {
      key: 'AIzaSyDr6bw-TZvIDfnLT3G2GTiB7HnmqZvRisc',
      libraries: 'places',
      language: 'ru'
    },
  installComponents: true
})

Vue.use(VueLazyload, {
  loading: require('../static/images/logo.gif')
})

WebFont.load({
  custom: {
    families: [
      'Baskerville Italic',
      'Century Gothic',
      'Cormorant Light',
      'Evolventa Regular',
      'Gotham Pro Regular'
    ]
  },
  events: false
})

svg4everybody()

Vue.use(VueGtag, {
  enabled: (process.env.NODE_ENV === 'production'),
  config: { id: 'UA-21039735-1' }
}, router)

Vue.use(VueYandexMetrika, {
  id: 44905927,
  router: router,
  env: process.env.NODE_ENV,
  options: {
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true,
    webvisor: true
  }
})

// Vue.use(VueJivosite, { widgetId: 'yVgJOyPuS5' })

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js